export const authRoles = {
  admin: ['Admin'],
  staff: ['Admin', 'Staff', 'admin'],
  driver: ['Admin', 'Staff', 'Driver'],
};

export type AuthRoles = typeof authRoles;
export type Role = 'Admin' | 'Staff' | 'Driver';
